import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import gridBlocks from "@/assets/images/landing-page/grid blocks.png";
import { MockupWindow, BoardMockup } from "@/pages/Public/components/ProductMockups";
import { trackCheckCtaClick } from "@/utils/analytics";
import { ROUTE_CONFIG } from "@/routes/config";

interface LandingIntroSectionProps {
	handleStart: (answer: "yes" | "no" | "unknown") => void;
}

export default function LandingIntroSection({ handleStart }: LandingIntroSectionProps) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const ts = (key: string) => t(`questionnaire.landing.${key}`);

	const handleCheckStart = () => {
		trackCheckCtaClick("hero");
		handleStart("yes");
	};

	return (
		<section className="relative w-full bg-[linear-gradient(28.54deg,#4680FC_6.44%,#1A2E6E_100%)] py-12 sm:py-32 px-4 flex justify-center overflow-hidden">
			<div
				className="absolute inset-0 bg-no-repeat bg-cover bg-center z-0"
				style={{ backgroundImage: `url(${gridBlocks})` }}
			/>
			<div className="relative z-10 flex flex-col md:flex-row justify-between items-center gap-12 max-w-[1500px] w-full">
				<div className="flex flex-col gap-14 max-w-[694px] w-full">
					<div className="flex flex-col gap-6">
						<h1 className="font-urbanist font-bold text-white text-[42px] md:text-[58px] leading-[120%]">
							{ts("title")}
						</h1>
						<p className="font-urbanist font-medium text-white text-[20px] md:text-[24px] leading-[140%]">
							{ts("subtitle")}
						</p>
					</div>
					<div className="flex flex-col sm:flex-row gap-4">
						<button
							className="min-h-[52px] bg-white border border-[#E6E6EC] rounded-[12px] px-[28px] py-[12px] text-[16px] font-medium font-urbanist text-[#1D243C] hover:bg-[#F0F4FF] transition-colors"
							onClick={handleCheckStart}
						>
							{ts("ctaPrimary")}
						</button>
						<button
							className="min-h-[52px] bg-transparent border border-white/60 rounded-[12px] px-[28px] py-[12px] text-[16px] font-medium font-urbanist text-white hover:bg-white/10 transition-colors"
							onClick={() => navigate(ROUTE_CONFIG.PRODUCT)}
						>
							{ts("ctaSecondary")}
						</button>
					</div>
					<p className="font-urbanist text-white/80 text-[14px] -mt-8">{ts("ctaNote")}</p>
				</div>

				<div className="w-full max-w-[460px] md:max-w-[620px]">
					<MockupWindow>
						<BoardMockup />
					</MockupWindow>
				</div>
			</div>
		</section>
	);
}
